<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />

    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="$t('content.cardTitle')">
        <template slot="actions">
          <va-button @click="toCreateContent()" icon="fa fa-plus"></va-button>
        </template>
        <div class="va-card__body" v-if="content.length < 1">
          <va-notification v-if="content.length < 1" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('content.cardMessage') }}
          </va-notification>
        </div>
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading && content.length > 0" class="flex xs12">
      <div class="row d-flex wrap align--start">
        <div class="flex xs12 sm6 lg6 xl6" v-for="(content, index) in content" :key="index">
          <ContentCard :content="content" @content-deleted="deleteContentItem" @content-duplicated="addContent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import ContentCard from '@/components/content/ContentCard.vue'
export default {
  components: { SwappingSquaresSpinner, ContentCard },
  mixins: [errorHandlerMixin],
  name: 'Content',
  data () {
    return {
      content: [],
    }
  },
  methods: {
    async toCreateContent () {
      await this.$router.push({
        name: 'create-content',
      })
    },
    async initContent () {
      this.content.splice(0, this.content.length, ...this.$store.getters.content)
      this.$store.commit('setLoading', false)
    },
    deleteContentItem (appContentId) {
      this.content = this.content.filter(item => item.appContentId !== appContentId)
    },
    addContent (newContent) {
      this.content.push(newContent)
    },
  },
  computed: {

  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getContentList')
      .then(() => this.initContent())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style lang="scss" scoped>

</style>
